import { render, staticRenderFns } from "./Envoy.vue?vue&type=template&id=5b1541bc"
import script from "./Envoy.vue?vue&type=script&lang=js"
export * from "./Envoy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports